<template>
    <div id="data">
        {{ result }}
    </div>
</template>

<script>
    export default {
        name: 'provider-data-viewer',
        data: function () {
            return {
                userId: this.$store.state.user.id,
                result: null,
            };
        },
        mounted() {
            this.providerDataViewerResult();
        },
        methods: {
            providerDataViewerResult() {
                const vm = this;

                // eslint-disable-next-line no-undef
                const result = Vue.backendApi().deliveryMethods().deliveryMethodProviders().then((response) => {
                    vm.result = response.data;
                    return response;
                })
                    // This is STUPID formatting but I cannot convince eslint not to error it.
                    .catch((error) => {
                        console.error(error);
                        vm.result = JSON.stringify(error);
                        return error;
                    });

                return result;
            },
        },
    };
</script>

<style scoped>
</style>
